import { Component, Input, OnInit } from "@angular/core";
import { Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-knob-cron",
  templateUrl: "./knob-cron.component.html",
  styleUrls: ["./knob-cron.component.scss"],
})
export class KnobCronComponent {
  @Input() size: number = 70;
  @Input() timeCron: number = 0;
  @Output() outTime = new EventEmitter<number>();

  dadosStorage: string = "";
  reloadStatus: boolean = false;

  constructor() {}

  insertDadosStorage(tipoConsulta: string, token: string) {
    localStorage.setItem(
      `${tipoConsulta}_${token}_reload`,
      new Date(Date.now()).toISOString()
    );
  }

  removeDadosStorage(tipoConsulta: string, token: string) {
    localStorage.removeItem(`${tipoConsulta}_${token}_reload`);
  }

  timeReconsulta(tipoConsulta: string, token: string) {
    try {
      this.dadosStorage = localStorage.getItem(
        `${tipoConsulta}_${token}_reload`
      );
      if (this.dadosStorage == null || this.dadosStorage == "") {
        return false;
      } else {
        let diferenca = new Date(
          new Date(Date.now()).getTime() - new Date(this.dadosStorage).getTime()
        );
        if (diferenca.getUTCMinutes() < 3) {
          return true;
        } else {
          this.removeDadosStorage(tipoConsulta, token);
          return false;
        }
      }
    } catch (error) {
      return false;
    }
  }

  cronReload(minutos: number, tipoConsulta: string, token: string) {
    let diffSec = 0;
    let minAEsperar = minutos * 60;
    let escape = 0;

    let aguardar = setInterval(() => {
      try {
        this.dadosStorage = localStorage.getItem(
          `${tipoConsulta}_${token}_reload`
        );

        if (this.dadosStorage != null && this.dadosStorage != "") {
          let diferenca = new Date(
            new Date(Date.now()).getTime() -
              new Date(this.dadosStorage).getTime()
          );
          diffSec = diferenca.getUTCSeconds() + 60 * diferenca.getUTCMinutes();
          this.timeCron = Math.round((diffSec * 100) / minAEsperar);

          if (this.timeCron > 100 || escape == minAEsperar) {
            return clearInterval(aguardar);
          }

          this.outTime.emit(this.timeCron);
        } else {
          return clearInterval(aguardar);
        }
      } catch (error) {
        return clearInterval(aguardar);
      }
      escape++;
    }, 1000);
  }
}
